<template>
  <div class="root_sidebar flex-col">
    <div class="group_1 flex-row justify-between" @mouseenter="showPanel = true;"
      :style="{ 'pointer-events': showPanel?'none':'auto' }">
      <img class="image_1" referrerpolicy="no-referrer"
        src="./assets/img/FigmaDDSSlicePNG7d0fa1e604e11556351b82b94d893321.png" />
    </div>
    <div v-if="showPanel">
      <div class="group_2 flex-col hello" @mouseleave="closePanel()">
        <div style="margin-left:-74px;margin-top:40px;">
          <el-tooltip effect="dark" content="回到主页" placement="right" :open-delay="200">
            <div class="image-wrapper_1 flex-row" @click="goToDashboard">
              <img class="label_1" referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG2cbe380422194cf4fb154d1067de5966.png" />
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="编辑资料" placement="right" :open-delay="200" >
            <div class="image-wrapper_2 flex-row" @click="openProfileEditor()">
              <img class="label_2" referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGb1af1fa311e605ba9fd7064fc489bf57.png" />
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="面试历史" placement="right" :open-delay="200">
            <div class="image-wrapper_3 flex-row" @click="goToInterviewHistory">
              <img class="label_3" referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG6ea71f825b5e3815181d9313a954ec33.png" />
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="用户反馈" placement="right" :open-delay="200">
            <div class="image-wrapper_4 flex-row" @click="showFeedback = true">
              <img class="label_4" referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG95ae4c2c55b8a61fcd58413d99b13576.png" />
            </div>
          </el-tooltip>
          <el-tooltip effect="dark" content="退出登录" placement="right" :open-delay="200">
            <div class="image-wrapper_5 flex-row" @click="logout()">
              <img class="label_5" referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNGb7d9eb953fb151e0d87e4eec23aa2a98.png" />
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    
    <!-- 用户反馈模态框 -->
    <div class="feedback-modal" v-if="showFeedback" @click.self="showFeedback = false">
      <div class="feedback-container">
        <div class="feedback-title">用户反馈</div>
        <div class="feedback-question">您和面试官的面试过程愉快吗？</div>
        
        <div class="emoji-container">
          <!-- 五个表情 - 您需要提供灰色版和彩色版的图片 -->
          <div 
            v-for="(emoji, index) in emojis" 
            :key="index" 
            class="emoji-item" 
            :class="{ 'selected': selectedEmoji === index }"
            @click="selectEmoji(index)"
          >
            <img 
              :src="selectedEmoji === index ? emoji.colorUrl : emoji.grayUrl" 
              :alt="emoji.name" 
              class="emoji-image"
            />
          </div>
        </div>
        
        <div class="feedback-hint">欢迎说说您的想法，面试官会努力做更好！</div>
        
        <textarea 
          class="feedback-textarea" 
          placeholder="您的意见对我们很重要，请告诉我们您的想法"
          v-model="feedbackText"
        ></textarea>
        
        <div class="feedback-buttons">
          <button class="submit-btn" @click="submitFeedback">提交</button>
          <button class="cancel-btn" @click="showFeedback = false">以后再说</button>
        </div>
      </div>
    </div>
    <user-profile-editor
        :visible.sync="showProfileEditor"
        :user-info="userInfo"
        @submit="handleProfileSubmit"
        @cancel="handleProfileCancel"
        @avatar-updated="handleAvatarUpdate"
      />
  </div>
</template>
<script>
import UserProfileEditor from '@/components/UserProfileEditor/index.vue';
export default {
  components: {
    UserProfileEditor
  },
  data() {
    return {
      showPanel: false,
      showFeedback: false,
      showProfileEditor: false,
      userInfo: {
        avatar: '',
        name: '',
        email: '',
        phone: '',
        address: ''
      },
      selectedEmoji: null,
      feedbackText: '',
      emojis: [
        { 
          name: '非常满意', 
          grayUrl: require('@/components/SideBar/assets/img/5-gray.png'),  // 需要您提供灰色版本
          colorUrl: require('@/components/SideBar/assets/img/5-light.png') // 需要您提供彩色版本
        },
        { 
          name: '满意', 
          grayUrl: require('@/components/SideBar/assets/img/4-2x.png'), 
          colorUrl: require('@/components/SideBar/assets/img/4-light2x.png')
        },
        { 
          name: '一般', 
          grayUrl: require('@/components/SideBar/assets/img/3-gray.png'), 
          colorUrl: require('@/components/SideBar/assets/img/3-light.png')
        },
        { 
          name: '不满意', 
          grayUrl: require('@/components/SideBar/assets/img/2-gray.png'), 
          colorUrl: require('@/components/SideBar/assets/img/2-light.png')
        },
        { 
          name: '非常不满意', 
          grayUrl: require('@/components/SideBar/assets/img/1-gray.png'), 
          colorUrl: require('@/components/SideBar/assets/img/1-light.png')
        }
      ]
    };
  },
  beforeMount() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/style/colorful_tooltip.css';//在public目录下
    document.head.appendChild(link);
    window.tooltipStyle = link;
  },
  beforeRouteLeave(to, from, next) {
    if (window.tooltipStyle) {
      document.head.removeChild(window.tooltipStyle);
      delete window.tooltipStyle;
    }
    next()
  },
  methods: {
    closePanel() {
      setTimeout(() => { this.showPanel = false; }, 10)
    },
    openProfileEditor() {
      console.log('openProfileEditor')
      // 在打开编辑器前获取最新的用户信息
      this.getUserInfo().then(() => {
        this.showProfileEditor = true
      })
    },
    async getUserInfo() {
      // 使用模拟数据替代API调用
      try {
        // 模拟异步操作
        const mockUserInfo = {
          avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png', // 默认头像
          name: '测试用户',
          email: 'test@example.com',
          phone: '13800138000',
          address: '北京市朝阳区',
          wechat: 'test_wechat'
        }
        
        // 模拟异步请求延迟
        await new Promise(resolve => setTimeout(resolve, 100))
        this.userInfo = mockUserInfo
        
        return {
          data: mockUserInfo
        }
      } catch (error) {
        this.$message.error('获取用户信息失败')
        throw error
      }
    },
    handleProfileSubmit(formData) {
      // 模拟提交成功
      setTimeout(() => {
        this.$message.success('更新成功')
        this.showProfileEditor = false
        this.userInfo = { ...this.userInfo, ...formData } // 直接更新本地数据
      }, 500)
    },
    handleProfileCancel() {
      this.showProfileEditor = false
    },
    handleAvatarUpdate(newAvatarUrl) {
      this.userInfo.avatar = newAvatarUrl
    },
    // 添加跳转到主页的方法
    goToDashboard() {
      this.$router.push('/store/dashboard');
    },
    // 添加跳转到面试历史的方法
    goToInterviewHistory() {
      this.$router.push('/interview_mianshilishi');
    },
    // 新增公开方法
    openFeedbackModal() {
      this.showFeedback = true;
    },
    // 选择表情
    selectEmoji(index) {
      this.selectedEmoji = index;
    },
    // 提交反馈
    submitFeedback() {
      if (this.selectedEmoji === null) {
        // 如果没有选择表情，提示用户
        alert('请选择一个表情来反馈您的体验');
        return;
      }
      
      // 准备反馈数据
      const feedbackData = {
        emojiIndex: this.selectedEmoji,
        emojiName: this.emojis[this.selectedEmoji].name,
        text: this.feedbackText
      };
      
      // 这里可以添加发送反馈到服务器的代码
      console.log('提交的反馈:', feedbackData);
      
      // 重置表单并关闭模态框
      this.selectedEmoji = null;
      this.feedbackText = '';
      this.showFeedback = false;
      
      // 提示用户反馈已提交
      this.$message({
        message: '感谢您的反馈！',
        type: 'success'
      });
    },
    logout(){
      this.$store.dispatch('user/logout')
    }
  }
};
</script>

<style scoped lang="css" src="./assets/index.css" />

<style scoped>
/* 用户反馈模态框样式 */
.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.feedback-container {
  width: 55vw;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 1.2vw;
  border: 1px solid rgba(177, 110, 249, 0.3);
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feedback-title {
  font-size: 2vw;
  font-weight: bold;
  background: linear-gradient(90deg, #B16EF9 0%, #7EB4EB 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2vh;
  text-align: center;
}

.feedback-question {
  font-size: 1.2vw;
  color: #666;
  margin-bottom: 2vh;
  text-align: center;
}

.emoji-container {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 2vh;
}

.emoji-item {
  width: 4vw;
  height: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s;
  position: relative;
  border: 2px solid transparent;
}

.emoji-item.selected {
  border-color: rgba(177, 110, 249, 0.6);
  transform: scale(1.1);
  box-shadow: 0 0 1vw rgba(126, 180, 235, 0.4);
}

.emoji-image {
  width: 3.5vw;
  height: 3.5vw;
  object-fit: contain;
  transition: transform 0.2s;
}

.emoji-item:hover .emoji-image {
  transform: scale(1.1);
}

.feedback-hint {
  font-size: 1vw;
  color: #999;
  margin-bottom: 1.5vh;
  text-align: center;
}

.feedback-textarea {
  width: 80%;
  height: 20vh;
  padding: 1vh 1vw;
  border-radius: 0.8vw;
  border: 1px solid rgba(126, 180, 235, 0.5);
  background: rgba(255, 255, 255, 0.7);
  font-size: 1vw;
  margin-bottom: 2vh;
  resize: none;
  outline: none;
}

.feedback-textarea:focus {
  border-color: rgba(177, 110, 249, 0.7);
  box-shadow: 0 0 0.5vw rgba(126, 180, 235, 0.3);
}

.feedback-buttons {
  display: flex;
  justify-content: space-between;
  width: 60%;
}

.submit-btn, .cancel-btn {
  width: 10vw;
  height: 8vh;
  border-radius: 2vw;
  font-size: 1vw;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
}

.submit-btn {
  background: linear-gradient(90deg, #7EB4EB, #B16EF9);
  color: white;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
}

.submit-btn:hover, .cancel-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}
</style>